const damageStateNameFromIndex = i => `DS${i + 1}`;

export default damageStateNameFromIndex;
